import React, { FC } from 'react'
import LabelFont from '../../../../Theme/Fonts/Label'

type Props = {
    caption?: string
}

const CaptionTextDisplay: FC<Props> = ({ caption }) => {
    if (!caption) {
        return null
    }
    return (
        <LabelFont numberOfLines={1} color="keshi-3">
            {caption}
        </LabelFont>
    )
}
export default CaptionTextDisplay
